"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingBookingOptions = void 0;
const React = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const loaders_and_spinners_1 = require("@kyruus/loaders-and-spinners");
const messages_1 = __importDefault(require("../../lib/messages"));
const hooks_1 = require("../../lib/hooks");
const constants_1 = require("../../lib/constants");
const styles_1 = require("./styles");
const LoadingBookingOptions = ({ loading }) => {
    const largeScreenSize = (0, hooks_1.useMediaQuery)(`(min-width: ${constants_1.BREAKPOINTS.large}px)`);
    const loadingMessage = loading
        ? messages_1.default.ariaLiveLoadingBookingInformation
        : messages_1.default.ariaLiveLoadingBookingInformationComplete;
    return (React.createElement(React.Fragment, null,
        React.createElement(styles_1.LoadingBookingOptionsMessage, { "data-testid": "booking-options-loading", "aria-live": "polite", "aria-atomic": "true" },
            React.createElement(intl_1.FormattedMessage, Object.assign({}, loadingMessage))),
        loading && (React.createElement(styles_1.LoadingCard, { role: "presentation" },
            React.createElement(loaders_and_spinners_1.ShimmeringLoaderBar, { height: 30, width: 100 }),
            largeScreenSize && React.createElement(loaders_and_spinners_1.ShimmeringLoaderBar, { height: 30, width: 100 })))));
};
exports.LoadingBookingOptions = LoadingBookingOptions;
//# sourceMappingURL=LoadingBookingOptions.js.map